<template>
  <v-container
    id="sponsor-forms"
    fluid
    tag="section"
  >
    <base-material-card
      color="#ac8a2e"
      icon="mdi-account-tie"
      inline
      class="px-5 py-3"
      title="Sponsors"
    >
      <template v-slot:after-title>
        <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#ac8a2e"
              dark
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                large
                color="#ac8a2e"
              >
                mdi-account-plus
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <validation-observer v-slot="{ handleSubmit }">
                  <form
                    id="altaSponsor"
                    @submit.prevent="handleSubmit(validateForm)"
                  >
                    <v-row
                      align="center"
                      justify="center"
                    >
                      <v-col cols="12">
                        <validation-provider
                          v-slot="{ errors }"
                          name="sponsor"
                          rules="max:20"
                        >
                          <v-text-field
                            v-model="dataForm.descripcion"
                            color="#ac8a2e"
                            :error-messages="errors"
                            name="input-6-1"
                            label="Sponsor"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </form>
                </validation-observer>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    form="altaSponsor"
                    type="submit"
                    @click="dialog = false"
                  >
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <v-row
        align="end"
        justify="end"
      >
        <v-col
          cols="5"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
        <v-col
          cols="auto"
        >
          <v-dialog
            v-model="dialogItem"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                Sponsor Seleccionado:
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="dataForm.descripcion"
                  readonly
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialogItem= !dialogItem"
                >
                  Aceptar
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="sponsors"
        :search.sync="search"
        :sort-by="['name', 'office']"
        :sort-desc="[false, true]"
        multi-sort
        @click:row="showItem"
      >
        <template
          v-if="$can('M_parametros')"
          v-slot:[`item.actions`]="{ item }"
        >
          <v-tooltip
            content-class="top"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click.stop="editItem(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip
            content-class="top"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click.stop="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        dialog: false,
        dialogItem: false,
        search: undefined,
        headers: [
          {
            text: 'Nombre',
            sortable: false,
            value: 'descripcion',
          },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        sponsors: [],
        editedIndex: -1,
        dataForm: {
          descripcion: '',
        },
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva sponsor' : 'Editar sponsor'
      },
      mode () {
        return this.editedIndex === -1 ? 'new' : 'edit'
      },
    },
    created () {
      this.getSponsor()
    },
    methods: {
      showItem (item) {
        this.dataForm = Object.assign({}, item)
        this.dialogItem = true
      },
      getSponsor: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/sponsor_get' }).then(response => { this.sponsors = response })
        /*
        this.$store.commit('loaderOn', 1)
        await this.$http.get('/api/sponsor_get',
                             {
                               headers: { Authorization: 'Bearer ' + this.$store.state.token },
                             },
        ).then(response => {
          this.sponsors = response.data
        })
        this.$store.commit('loaderOff')
        */
      },
      editItem (item) {
        this.editedIndex = this.sponsors.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.dataForm = Object.assign({}, null)
          this.editedIndex = -1
        })
      },
      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/sponsor_delete/' + item.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Eliminacion de sponsor exitosa'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getSponsor()
      },
      validateForm (scope) {
        this.enviarSponsor()
      },
      enviarSponsor: async function () {
        const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/sponsor_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.getSponsor()
          this.close()
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de sponsor exitosa'] })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
      },
    },
  }
</script>
